module.exports = __webpack_public_path__ + "static/img/logo-round-sm.d7b8992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo-round-sm.png
// module id = 2CIM
// module chunks = 1